import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { ShadowConstraintService } from "src/app/services/shadowConstraint.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ShadowConstraint } from "src/app/models/shadowConstraint.model";
import { ToastService } from "src/app/services/toast.service";
import { forkJoin } from "rxjs";
import { Enum } from "src/app/models/enum.model";
import { ConstraintTypeEnum } from "src/app/enums/constraintType.enum";
import { OperatorTypeEnum } from "src/app/enums/operatorType.enum";
import { DeviceVersion } from "src/app/models/deviceVersion.model";
import { DeviceVersionService } from "src/app/services/deviceVersionService";

import { trackById } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-create-shadow-constraint-dialog",
    templateUrl: "createShadowConstraintDialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["createShadowConstraintDialog.component.scss"],
})
export class CreateShadowConstraintDialogComponent implements OnInit {
    isFormLoading = false;
    isLoading = false;
    deviceVersions: DeviceVersion[];
    constraintTypes: Enum[];
    operatorTypes: Enum[];
    ConstraintTypeEnum = ConstraintTypeEnum;
    OperatorTypeEnum = OperatorTypeEnum;

    constructor(
        public dialogRef: MatDialogRef<CreateShadowConstraintDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public shadowConstraint: ShadowConstraint,
        private shadowConstraintService: ShadowConstraintService,
        private deviceVersionService: DeviceVersionService,
        private toastService: ToastService,
    ) {}

    ngOnInit() {
        this.isFormLoading = true;
        this.deviceVersions = [];
        this.constraintTypes = [];
        this.operatorTypes = [];
        forkJoin({
            deviceVersions:
                this.deviceVersionService.getDeviceVersionLookupList(),
            constraintTypes: this.shadowConstraintService.getConstraintTypes(),
            operatorTypes: this.shadowConstraintService.getOperatorTypes(),
        }).subscribe(
            (result) => {
                this.deviceVersions = result.deviceVersions;
                this.constraintTypes = result.constraintTypes;
                this.operatorTypes = result.operatorTypes;
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    create() {
        this.isLoading = true;
        this.shadowConstraintService.create(this.shadowConstraint).subscribe(
            (response) => {
                this.isLoading = false;
                this.toastService.showSuccess(
                    "Shadow constraint added successfully",
                    true,
                );
                this.dialogRef.close(true);
            },
            (error) => {
                this.isLoading = false;
                this.toastService.showError(error);
            },
        );
    }


    isDisabled() {
        return (
            !this.shadowConstraint.deviceVersionId ||
            !this.shadowConstraint.field ||
            this.shadowConstraint.constraintTypeId === undefined ||
            (this.shadowConstraint.constraintTypeId !==
                ConstraintTypeEnum.Readonly &&
                this.shadowConstraint.constraintTypeId !==
                    ConstraintTypeEnum.SuperAdminOnly &&
                ((this.shadowConstraint.constraintTypeId !==
                    ConstraintTypeEnum.Rename &&
                    this.shadowConstraint.operatorTypeId === undefined) ||
                    !this.shadowConstraint.operatorValue)) ||
            (this.shadowConstraint.constraintTypeId ===
                ConstraintTypeEnum.Bounded &&
                (this.shadowConstraint.operatorTypeId2 === undefined ||
                    !this.shadowConstraint.operatorValue2))
        );
    }

    public trackById = trackById;
}
